import { z } from 'zod';

/** Operational address of a place — editable by Gerente (BR-IDT-14). */
export const PlaceOperationalAddressBodySchema = z.object({
  countryId: z.uuid(),
  stateId: z.uuid().nullable().optional(),
  cityId: z.uuid().nullable().optional(),
  stateText: z.string().nullable().optional(),
  cityText: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  street: z.string().min(1),
  number: z.string().nullable().optional(),
  complement: z.string().nullable().optional(),
  neighborhood: z.string().nullable().optional(),
  reference: z.string().nullable().optional(),
});

export type PlaceOperationalAddressBody = z.infer<typeof PlaceOperationalAddressBodySchema>;

export const PlaceOperationalAddressResponseSchema = z.object({
  placeId: z.uuid(),
  operationalAddress: PlaceOperationalAddressBodySchema,
  updatedAt: z.string(),
});

export type PlaceOperationalAddressResponse = z.infer<typeof PlaceOperationalAddressResponseSchema>;

/** GET — read operational address + place summary (no fiscal/legal fields). */
export const GetPlaceOperationalAddressResponseSchema = z.object({
  placeId: z.uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  operationalAddress: PlaceOperationalAddressBodySchema.nullable(),
});

export type GetPlaceOperationalAddressResponse = z.infer<
  typeof GetPlaceOperationalAddressResponseSchema
>;
